<template>
  <div>
    <template v-if="innerFile">
      <div class="mb-3">
        <v-btn text color="primary" :href="innerFile.lien" download target="_blank">{{ innerFile.name }}</v-btn>
        <v-btn icon color="error" @click="deleteFile" title="Supprimer"><v-icon>mdi-delete</v-icon></v-btn>
      </div>
    </template>
    <template v-else>
      <v-file-input
        v-bind="$attrs"
        outlined
        dense
        truncate-length="30"
        :style="{ width: width + 'px' }"
        @change="handleChange"
        v-model="fileInput"
        persistent-hint
        :disabled="uploading || updating"
        :loading="uploading || updating"
        :messages="messages"
        :rules="fileRules"
        :accept="accepts"
      ></v-file-input>
    </template>
    <v-alert type="warning" border="left" text icon="mdi-alert-circle-outline" v-show="error" :style="{ width: width + 'px' }"
      ><span class="black--text"
        >Une erreur est survenue lors du téléversement du fichier. Veuillez rééssayer plus tard ou utilisez un fichier plus petit.</span
      >
    </v-alert>
  </div>
</template>

<script>
import { Api, Queue } from "@/plugins/api"

// @group Champs
export default {
  props: {
    width: { type: String, default: "420" },
    code: { type: String, required: true },
    file: { type: Object, default: undefined },
    live: { type: Object },
    optional: { type: Boolean, default: false }
  },

  data() {
    return {
      fileInput: null,
      uploading: false,
      updating: false,
      innerFile: undefined,
      accepts: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png",
      error: false
    }
  },

  computed: {
    messages() {
      if (this.uploading) {
        return "Chargement de la pièce jointe en cours..."
      }
      if (this.updating) {
        return "Téléversement en cours..."
      }
      return ""
    },
    fileRules() {
      if (this.fileInput) {
        if (this.live) {
          return [(v) => !this.uploading, (v) => !this.updating, (v) => this.validateFileExtension() || "Format non-accepté (" + this.accepts + ")"]
        } else {
          return [(v) => !this.updating, (v) => this.validateFileExtension() || "Format non-accepté (" + this.accepts + ")"]
        }
      } else {
        if (this.optional) {
          return []
        } else {
          return [(v) => "Fichier requis"]
        }
      }
    }
  },

  created() {
    if (this.file && this.file.name && this.file.lien) {
      this.innerFile = this.file
    } else {
      this.innerFile = undefined
    }
  },

  watch: {
    file() {
      if (this.file && this.file.name && this.file.lien) {
        this.innerFile = this.file
      } else {
        this.innerFile = undefined
      }
    }
  },

  methods: {
    async handleChange(event) {
      if (!this.validateFileExtension() || !this.fileInput) {
        return
      }
      this.error = false
      this.uploading = true
      let fileDto = await this.getDto()
      this.uploading = false
      if (this.live) {
        this.updating = true
        Queue.enqueue(() =>
          Api.post(this.live.endpoint, {
            fileId: this.live.fileId,
            cle: this.live.cle,
            value: fileDto,
            estUnFichier: true
          })
            .then((res) => {
              this.innerFile = res.data
              this.$emit("file-uploaded", res.data)
            })
            .catch(() => {
              this.fileInput = undefined
              this.innerFile = undefined
              this.error = true
            })
            .finally(() => {
              this.updating = false
            })
        )
      }
      this.$emit("input", fileDto)
    },

    deleteFile() {
      if (this.innerFile) {
        if (this.live) {
          Api.post(this.live.endpoint + "/delete-document", {
            sasDocumentId: this.innerFile.id,
            fileId: this.live.fileId,
            cle: this.live.cle
          }).then(this.deleteFilePostTreatment)
        } else {
          Api.post("/sas-documents/delete/" + this.innerFile.id).then(this.deleteFilePostTreatment)
        }
      } else {
        this.innerFile = undefined
        this.fileInput = undefined
      }
    },

    deleteFilePostTreatment() {
      this.$emit("file-deleted", this.innerFile.id)
      this.innerFile = undefined
      this.fileInput = undefined
    },

    validateFileExtension() {
      if (this.fileInput) {
        let split = this.fileInput.name.split(".")
        let extension = split[split.length - 1].toLowerCase()
        return this.accepts.indexOf(extension) > -1
      }
      return true
    },

    async getDto() {
      if (this.fileInput) {
        var fileContent = await this.fileInput.arrayBuffer()
        return {
          name: this.fileInput.name,
          size: this.fileInput.size,
          type: this.fileInput.type,
          content: Array.from(new Uint8Array(fileContent))
        }
      }
    }
  }
}
</script>

<style>
</style>